<template>
  <div>
    <div class="row">
      <div class="form-group col-md-4">
        <label class="mb-1"><b><u class="section-title"><i class="fas fa-user-graduate"></i>&nbsp;&nbsp;Progreso de Estudiantes&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u></b></label>
        <v-select v-model="filterCourse" :options="courses" class="my-custom-select" placeholder="Todos los cursos"></v-select>
      </div>
      <div class="form-group col-md-4">
        <label class="mb-1"><b>Alumno</b></label>
        <v-select v-model="filterStudent" :options="students" class="my-custom-select" placeholder="Todos los alumnos"></v-select>
      </div>
      <div class="col-md-12">
        <button class="btn btn-sm btn-success btn-icon-split" title="Filtrar" @click="getRecords(null)"><i class="fas fa-filter"></i> Filtrar</button>
        <button class="btn btn-sm btn-danger btn-icon-split" title="Borrar filtro" @click="clearFilter()"><i class="fas fa-ban"></i></button>
        <hr>
      </div>
    </div>

    <div class="alert-reliability">
      <i class="fas fa-info-circle"></i>
      Los tiempos y puntajes los cronometra el navegador del alumno y el servidor los guarda sin validar,
      así que sirven como <b>seguimiento</b>, no como evidencia de auditoría.
    </div>

    <b-overlay :show="loading" rounded="sm">
      <div class="table-responsive tableBg">
        <table class="table table-striped table-bordered zero-configuration">
          <thead>
            <tr>
              <th>#</th>
              <th>Acciones</th>
              <th>Alumno</th>
              <th>Curso</th>
              <th>Módulos</th>
              <th>Lectura</th>
              <th>Práctica</th>
              <th>Ingresos</th>
              <th>Vigencia</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(record, index) in records" :key="index">
              <td>{{ record.index }}</td>
              <td>
                <button class="btn btn-sm btn-success btn-icon-split btn-xs" @click="showRecord(record.id)" title="Ver detalle">
                  <span class="icon text-white"><i class="fas fa-eye icon_white"></i></span>
                </button>
              </td>
              <td>{{ record.studentname }}<br><small class="text-muted">{{ record.studentuser }}</small></td>
              <td>{{ record.coursename }}</td>
              <td>
                <span :class="record.modulesDone === record.modulesTotal && record.modulesTotal > 0 ? 'badge badge-success' : 'badge badge-secondary'">
                  {{ record.modulesDone }} / {{ record.modulesTotal }}
                </span>
              </td>
              <td>
                <div class="progress-mini"><div class="progress-mini-bar" :style="{ width: record.readPercent + '%' }"></div></div>
                <small>{{ record.readPercent }}% &middot; {{ record.readDone }} de {{ record.readRequired }}</small>
              </td>
              <td>
                <div class="progress-mini"><div class="progress-mini-bar" :style="{ width: record.practicePercent + '%' }"></div></div>
                <small>{{ record.practicePercent }}% &middot; {{ record.practiceDone }} de {{ record.practiceRequired }}</small>
              </td>
              <td>
                {{ record.logins }}
                <br><small class="text-muted">{{ record.lastAccess }}</small>
              </td>
              <td>
                {{ record.startDate }} – {{ record.endDate }}
                <br>
                <small :class="record.daysLeft !== null && record.daysLeft < 0 ? 'text-danger' : 'text-muted'">
                  {{ vigencyLabel(record.daysLeft) }}
                </small>
              </td>
            </tr>
            <tr v-if="total == 0">
              <td colspan="9">No hay registros</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>#</th>
              <th>Acciones</th>
              <th>Alumno</th>
              <th>Curso</th>
              <th>Módulos</th>
              <th>Lectura</th>
              <th>Práctica</th>
              <th>Ingresos</th>
              <th>Vigencia</th>
            </tr>
          </tfoot>
        </table>
      </div>
      <!-- Contenedor de paginación -->
      <div class="pagination-container d-flex justify-content-end">
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item" v-for="link in links" :class="{'disabled': link.url == null, 'active': link.active}">
              <a class="page-link" @click="getRecords(link.url)" v-html="link.label"></a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="text-right">
        <span><i style="font-size: 14px; color: #7A7A7A">Cantidad de registros: {{total}}</i></span>
        <hr>
        <br>
      </div>
    </b-overlay>

    <modal-record :id="recordId" :showModal.sync="showModalRecord"></modal-record>
  </div>
</template>

<script>
import ModalRecord from './partials/ModalRecord.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { BOverlay } from 'bootstrap-vue'

export default {
  components: { ModalRecord, BOverlay, vSelect },
  data() {
    return {
      records: [],
      loading: false,
      courses: [],
      students: [],
      filterCourse: null,
      filterStudent: null,
      links: {},
      total: 0,
      recordId: null,
      showModalRecord: false,
    }
  },
  created() {
    this.getCourses()
    this.getStudents()
    this.getRecords(null)
  },
  methods: {
    vigencyLabel(days) {
      if (days === null) return 'Sin fecha'
      if (days < 0) return 'Vencido hace ' + Math.abs(days) + ' días'
      if (days === 0) return 'Vence hoy'
      return 'Quedan ' + days + ' días'
    },
    getCourses() {
      axios.get('/studentProgress/getCourses')
        .then(response => { this.courses = response.data.data })
        .catch(error => { console.error(error) })
    },
    getStudents() {
      axios.get('/studentProgress/getStudents')
        .then(response => { this.students = response.data.data })
        .catch(error => { console.error(error) })
    },
    clearFilter() {
      this.filterCourse = null
      this.filterStudent = null
      this.getRecords(null)
    },
    getRecords(url = null) {
      this.loading = true
      let page = 1
      if (url) {
        let param = new URL(url)
        page = param.searchParams.get("page")
      }
      const params = {
        course_id: this.filterCourse ? this.filterCourse.value : null,
        user_id: this.filterStudent ? this.filterStudent.value : null,
      }
      axios.get(`/studentProgress/records?page=${page}`, { params: params })
        .then(response => {
          this.records = response.data.data.data
          this.links = response.data.data.links
          this.total = response.data.data.total
        })
        .catch((error) => { console.log(error) })
        .finally(() => { this.loading = false })
    },
    showRecord(id) {
      this.recordId = id
      this.showModalRecord = true
    },
  }
}
</script>

<style scoped>
.pagination-container {
  margin-top: 10px !important;
}
</style>
